let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("80ngU")).then(() => parcelRequire('eWFII'));